import { useQuery } from "@apollo/client/react";
import TREAT_BALANCE_QUERY from "@graphql/queries/TreatBalance";
import { useWatchUserWsEvent } from "@hooks";
import { useMemo } from "react";

export type TreatBalance = {
  totalBalance: number;
  monthlyBalance: number;
  permanentBalance: number;
  nextResetAt: string | null;
};

export function useTreatBalance() {
  const { data, loading, error, refetch } = useQuery(
    TREAT_BALANCE_QUERY,
    { fetchPolicy: "cache-and-network" },
  );

  useWatchUserWsEvent({
    onMessage: refetch,
    eventName: "treat_balance_update",
  });

  const raw = data?.treatBalance ?? null;

  const balance = useMemo<TreatBalance | null>(() => {
    if (!raw) return null;
    return {
      totalBalance: raw.totalBalance,
      monthlyBalance: raw.monthlyBalance,
      permanentBalance: raw.permanentBalance,
      nextResetAt:
        typeof raw.nextResetAt === "string" ? raw.nextResetAt : null,
    };
  }, [raw]);

  return { balance, loading, error, refetch };
}
